<div [formGroup]="form">
  <div class="card mt-3">
    <div class="card-header">
      <a id="TargetFingerabdruck"></a>
      <h3>
        <i class="icon-fingerabdruck"></i> <span i18n>Fingerabdruck</span>
        <span class="float_right" *ngIf="appConfig.isAssistantAvailable">
          <button type="button" class="btn btn-primary btn-assistent mb-1 me-1" (click)="enableAssistant()"
                  style="width: 170px; background-color: #367297">
            <i class="icon-assistant" style="font-size: 20px; vertical-align: text-bottom"></i>
            <span i18n>Assistent starten</span>
          </button>
        </span>
      </h3>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header card-header-detail" i18n>Fingerabdruck</div>
            <div class="card-body">
              <div class="row" *ngIf="appConfig.umgebung !== 'VIDEX' && showBiometrieMessage">
                <div class="col-md-12 fw-bold mb-2" style="color: rgb(202, 125, 125);">
                  <span i18n>Die Fingerabdrücke wurden im Rahmen eines Schengen-Visums vor mehr als 59 Monaten erfasst und können daher nicht übernommen werden.</span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-check">
                    <label class="form-check-label">
                      <input type="radio"
                             class="form-check-input"
                             value="ja"
                             [checked]="true"
                             [attr.disabled]="isAntragstellerYoungerThan12() ? true : null"
                             formControlName="erforderlich"
                      >
                      <span i18n>Fingerabdrücke erfassen</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-check">
                    <label class="form-check-label">
                      <input type="radio"
                             class="form-check-input"
                             value="nein"
                             [attr.disabled]="isAntragstellerYoungerThan12() ? true : null"
                             formControlName="erforderlich"
                      >
                      <span i18n>Keine Fingerabdrücke erforderlich</span>
                    </label>
                  </div>
                </div>
              </div>

              <div class="row" *ngIf="form.controls['erforderlich'].value === 'ja'">
                <div class="col-md-4">
                  <label for="scannertyp-fingerabdruck" i18n class="pull-right">Erfassen mit:</label>
                </div>
                <div class="col-md-4">
                  <select class="form-select form-select-sm mb-3"
                          id="scannertyp-fingerabdruck"
                          formControlName="scannertyp"
                          (change)="changeDevice()">
                    <option *ngFor="let listItem of erfassungListItems; let i = index"
                            [attr.selected]="i === 0 ? true : null"
                            value="{{ listItem.key }}">{{ listItem.value }}
                    </option>
                  </select>
                </div>
                <div class="col-md-4">
                  <button type="button" class="btn btn-primary  me-1 pull-left" (click)="captureFingerabdruck()"
                          style="background-color: #367297; width: 210px"
                          [disabled]="isCaptureButtonDisabled()"
                  ><span i18n>Fingerabdrücke erfassen</span></button>
                </div>
              </div>
              <div class="row" *ngIf="form.controls['erforderlich'].value !== 'ja'">
                <div class="col-md-4">
                  <label for="ausnahmegrund" i18n class="pull-right">Begründung:</label>
                </div>
                <div class="col-md-4">
                  <select class="form-select form-select-sm mb-3"
                          id="ausnahmegrund"
                          [attr.disabled]="isAntragstellerYoungerThan12() ? true : null"
                          formControlName="ausnahmegrund">
                    <option *ngFor="let listItem of fingerabdruckListItemsFiltered; let i = index"
                            [attr.selected]="i === 0 ? true : null"
                            value="{{ listItem.key }}">{{ listItem.value }}
                    </option>
                  </select>
                </div>

              </div>
              <div class="row" *ngIf="form.value.wasCapturingSuccessful === true">
                <div class="col-md-12" style="color: #4DBD74">
                  <span i18n>Die Aufnahme der Fingerabdrücke ist abgeschlossen.</span>
                </div>
              </div>
              <div class="row" *ngIf="form.value.wasCapturingSuccessful === false">
                <div class="col-md-12" style="color: red">
                  <span i18n>Die Fingerabdrücke konnten nicht erfasst werden.</span>
                </div>
              </div>
              <div class="row" *ngIf="!this.hasDevices">
                <div class="col-md-12" style="color: red">
                  <span i18n>Die Erfassung der Fingerabdrücke ist nicht möglich, da kein Fingerabdruckscanner gefunden wurde. Bitte schließen Sie einen Fingerabdruckscanner an. Ggf. ist es notwendig, den Fingerabdruckscanner kurz vom Stromnetz zu trennen.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
